import { render, staticRenderFns } from "./HotQuestionShape.vue?vue&type=template&id=46ac61cb&scoped=true&"
import script from "./HotQuestionShape.vue?vue&type=script&lang=js&"
export * from "./HotQuestionShape.vue?vue&type=script&lang=js&"
import style0 from "./HotQuestionShape.vue?vue&type=style&index=0&id=46ac61cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac61cb",
  null
  
)

export default component.exports